import React, { Component } from 'react';

import classNames from 'classnames';

import ReduxConnect from 'Demora/redux-connect';

import socialHttp from '../../../../../utils/socialHttp';

import modal from 'Demora/modals/modal';

import ShowFeels from './ShowFeels';

import { withRouter } from 'react-router-dom';

class Feel extends Component {
	constructor(props) {
		super(props);

		this.state = {
			feed: null,
			toggleToolTipPostAge: {},
		};
	}

	changeFeel = (type, state, event) => {
		event.preventDefault();

		if (type == 's') {
			return this.share(state);
		}

		this.changeFeelInStore(type, state);

		const post = this.props.post;

		socialHttp('put', '/data/feed/' + this.props.post.id + '/feels', {
			feel: type,
			post: !!post.nodb ? post : undefined,
			state,
		}).catch((data) => {
			this.changeFeelInStore(type, !state);
		});
	}

	changeFeelInStore(type, state) {
		const post = this.props.post;

		const feed = {};

		const splitobj = post.id.split('-');

		const r = splitobj.slice(0, 2).join('-');

		const obj = splitobj.slice(0, 3).join('-');

		const comment = (splitobj.length == 4) && splitobj.slice(0, 4).join('-');

		feed[r] = { p: {} };
		feed[r].p[obj] = {};

		const fobj = this.props.feed[r].p[obj];

		const fobj2 = feed[r].p[obj];

		if (!comment) {
			fobj2.a = {};
			fobj2.a[type] = {
				c: post.a[type].c + (state ? 1 : -1),
				u: state,
			};
		} else {
			fobj2.c = { p: {} };
			fobj2.c.p[comment] = { a: {} };

			fobj2.c.p[comment].a[type] = {
				c: post.a[type].c + (state ? 1 : -1),
				u: state,
			};
		}

		this.props.dispatch({
			type: 'STORE_FEED',
			data: {
				feed,
			},
		});
	}

	share(state) {
		if (!state) {
			return;
		}

		this.changeShareInStore(true);

		socialHttp('post', '/data/feed/' + this.props.post.id + '/share')
			.catch((data) => {
				this.changeShareInStore(false);
			})
			.catch((e) => {
				throw e;
			});
	}

	changeShareInStore(state) {
		let post = this.props.post;

		let feed = {};

		feed[post.obj] = {};
		feed[post.obj].p = {};
		feed[post.obj].p[post.id] = { a: {} };
		feed[post.obj].p[post.id].a.s = {
			c: post.a.s.c + (state ? 1 : -1),
			u: state,
		};

		this.props.dispatch({
			type: 'STORE_FEED',
			data: {
				feed: feed,
			},
		});
	}

	showInteractions = (e) => {
		e.preventDefault();

		modal({
			id: 'showFeels',
			header: 'Interactions',
			body: <ShowFeels obj={this.props.post.id} />,
			close: false,
		});
	}

	render() {
		const props = this.props;

		const post = props.post;

		if (!post.a) {
			return null;
		}

		const feels = post.a;

		let countFeels = 0;

		return (
			<span className='stats'>
				{props.feels.order.map((v) => {
					if (!feels[v]) {
						return '';
					}

					countFeels += feels[v].c;

					if (post.id.split('-')[1] != 'u' && v != 'l') {
						return null;
					}

					if (post.can.i) {
						return (
							<a
								href='#'
								key={v}
								onClick={(event) =>
									this.changeFeel(v, !feels[v].u, event)
								}
								className='btn btn-default stat-item btn-responsive'
							>
								<i
									className={classNames(
										'icon',
										feels[v].u
											? this.props.feels.feels[v].m[1]
											: this.props.feels.feels[v].m[0]
									)}
								></i>{' '}
								{feels[v].c}
							</a>
						);
					} else {
						return (
							<a
								key={v}
								className='btn btn-default stat-item btn-responsive'
								href={props.location.pathname}
							>
								<i
									className={classNames(
										'icon',
										feels[v].u
											? this.props.feels.feels[v].m[1]
											: this.props.feels.feels[v].m[0]
									)}
								></i>{' '}
								{feels[v].c}
							</a>
						);
					}
				})}

				{countFeels > 0 && post.can.i && (
					<span className='text-center small feel-show-interactions'>
						<a href='#' onClick={(e) => this.showInteractions(e)}>
							See who
						</a>
					</span>
				)}
			</span>
		);
	}
}

export default withRouter(
	ReduxConnect(Feel, {
		user: 'user',
		feels: 'feels',
		feed: 'feed',
	})
);
